import { Link, Outlet, useLocation, useParams } from 'react-router-dom';
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  HStack,
  Image,
} from '@chakra-ui/react';

import { ReactComponent as ChevronRightIcon } from '../../assets/icons/chevron-right.svg';
import { useGetTeamMemberByIdQuery } from '../../services';

export const UsersLayout = () => {
  const location = useLocation();
  const params = useParams();
  const { userId } = params;
  const status = params.status || 'all';

  const { data } = useGetTeamMemberByIdQuery(Number(userId), {
    skip: !userId,
  });

  return (
    <Box mx="8" h="full" display="flex" flexDirection="column">
      <Breadcrumb separator={<ChevronRightIcon />}>
        <BreadcrumbItem>
          <HStack fontSize="xs" color="custom_blue.1">
            <Image src="/sidebar/users.svg" alt="roles icon" boxSize="4" />
            <Box>Users</Box>
          </HStack>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage={location.pathname.endsWith(status)}>
          <BreadcrumbLink
            as={Link}
            to={`/users/${status}`}
            fontSize="xs"
            color="custom_blue.1"
            textTransform="capitalize"
          >
            {status ? status : 'All'} Users
          </BreadcrumbLink>
        </BreadcrumbItem>

        {(location.pathname.includes('new-user') || userId) && (
          <BreadcrumbItem
            isCurrentPage={location.pathname.endsWith('new-user')}
          >
            {userId ? (
              <BreadcrumbLink
                as={Link}
                to={`/users/${status}/${userId}`}
                fontSize="xs"
                color="custom_blue.1"
              >
                {data?.data.firstName}
              </BreadcrumbLink>
            ) : (
              <BreadcrumbLink
                as={Link}
                to={`/users/${status}/new-user`}
                fontSize="xs"
                color="custom_blue.1"
              >
                Add New User
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>
        )}
      </Breadcrumb>

      <Outlet />
    </Box>
  );
};
